module.exports = __webpack_public_path__ + "img/s-sl-img-4.cdf35064.png";